/**
 * 评价/盘点任务状态的中文展示与配色。
 * 跨页面共享，避免 PC 各页面分别硬编码 PENDING/SUBMITTED 等英文状态。
 */
export const TASK_STATUS_LABEL: Record<string, string> = {
  PENDING: '待提交',
  DRAFTED: '草稿',
  SUBMITTED: '已提交',
  WITHDRAWN: '已撤回',
  LOCKED: '已锁定',
};

export const TASK_STATUS_COLOR: Record<string, string> = {
  PENDING: 'orange',
  DRAFTED: 'blue',
  SUBMITTED: 'green',
  WITHDRAWN: 'default',
  LOCKED: 'red',
};

export function taskStatusLabel(status?: string | null): string {
  if (!status) return '-';
  return TASK_STATUS_LABEL[status] || status;
}

export function taskStatusColor(status?: string | null): string {
  if (!status) return 'default';
  return TASK_STATUS_COLOR[status] || 'default';
}
